import { CLIENT_CONTEXT_PREFIX } from "../settings/index.js";
import { GraphqlMiddlewareCache } from "./ClientCache.js";
import {
  clientCacheEnabledAtBuild,
  importMetaServer
} from "#nuxt-graphql-middleware/config";
export function encodeContext(context) {
  return Object.entries(context).reduce(
    (acc, [key, value]) => {
      if (typeof value === "string") {
        acc[CLIENT_CONTEXT_PREFIX + key] = value;
      }
      return acc;
    },
    {}
  );
}
export function sortQueryParams(obj) {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObj = {};
  for (const key of sortedKeys) {
    sortedObj[key] = obj[key];
  }
  return sortedObj;
}
export function getOrCreateClientCache(app, config) {
  if (importMetaServer || !clientCacheEnabledAtBuild) {
    return;
  }
  if (!config.graphqlMiddleware.clientCacheEnabled) {
    return;
  }
  if (!app.$graphqlCache) {
    app.$graphqlCache = new GraphqlMiddlewareCache(
      config.graphqlMiddleware.clientCacheMaxSize
    );
  }
  return app.$graphqlCache;
}
